import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const DownloadIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "download",
  "DownloadIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M8.6665 2L8.6665 8.39052L10.9998 6.05719L11.9426 7L7.99984 10.9428L4.05703 7L4.99984 6.05719L7.33317 8.39052L7.33317 2L8.6665 2ZM2.99984 9.33333V12.6667H12.9998V9.33333H14.3332V14H1.6665V9.33333H2.99984Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default DownloadIcon;
